import { gql } from "@apollo/client";

export const MACHINE_DOCUMENTS = gql`
	query machineDocuments($id: String!,$pin:String!) {
		machineDocuments(id: $id,pin:$pin) {
			_id
			data
			public
		}
	}
`;
